// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/icon/index.css
// module id = 868
// module chunks = 153